import type { TokenType } from '@parser';

export const BREAK = 'BREAK' as TokenType;
export const PROLOGUE = 'prologue' as TokenType;
export const TRUE = 'true' as TokenType;
export const FALSE = 'false' as TokenType;
export const NULL = 'null' as TokenType;
export const ID = 'id' as TokenType;
export const DIRECTIVE = 'directive' as TokenType;
export const CLASS = 'class' as TokenType;
export const COLON = 'colon' as TokenType;
export const COMMA = 'comma' as TokenType;
export const NUMBER = 'number' as TokenType;
export const LBRACE = 'lbrace' as TokenType;
export const RBRACE = 'rbrace' as TokenType;
export const LBRACKET = 'lbracket' as TokenType;
export const RBRACKET = 'rbracket' as TokenType;
export const LPAREN = 'lparen' as TokenType;
export const RPAREN = 'rparen' as TokenType;
export const STRING = 'string' as TokenType;
export const ARROW = 'arrow' as TokenType;
export const TILDE = 'tilde' as TokenType;
export const LOCALE = 'locale' as TokenType;
export const UNKNOWN = 'unknown' as TokenType;
